export const clampDayToMonth = (year, monthIndex, day) => {
  const last = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
  const safe = Math.min(Math.max(1, day || 1), last);
  return new Date(Date.UTC(year, monthIndex, safe));
};

export const parseMonthValue = (yyyyMm) => {
  if (!yyyyMm || !/^\d{4}-\d{2}$/.test(yyyyMm)) return null;
  const [y, m] = yyyyMm.split('-').map(Number);
  return { year: y, monthIndex: m - 1 };
};

export const toYyyyMm = (date) => {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
};

export const parseDateInput = (value) => {
  if (!value) return null;
  const [Y, M, D] = value.split('-').map(Number);
  if (!Y || !M || !D) return null;
  return new Date(Date.UTC(Y, M - 1, D));
};

export const formatDateInput = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const sameMonthAs = (isoString, year, monthIndex) => {
  if (!isoString) return false;
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return false;
  return d.getUTCFullYear() === year && d.getUTCMonth() === monthIndex;
};

export const getRefDateForMonth = (year, monthIndex) => {
  const today = new Date();
  const todayUTC = new Date(Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate()
  ));

  const firstSel = new Date(Date.UTC(year, monthIndex, 1));
  const lastSel = new Date(Date.UTC(year, monthIndex + 1, 0));

  if (todayUTC.getUTCFullYear() === year && todayUTC.getUTCMonth() === monthIndex) {
    return todayUTC;
  }
  if (lastSel.getTime() < firstSel.getTime() ? false : lastSel.getTime() < todayUTC.getTime()) {
    return lastSel;
  }
  const dayBeforeFirst = new Date(Date.UTC(year, monthIndex, 0));
  return dayBeforeFirst;
};

export const computeDespesaStatus = ({ data_vencimento, data_pagamento, refDate }) => {
  const ref = refDate instanceof Date ? new Date(refDate) : new Date();
  ref.setUTCHours(0, 0, 0, 0);

  const pago = data_pagamento ? new Date(data_pagamento) : null;
  const venc = data_vencimento ? new Date(data_vencimento) : null;

  if (pago && !Number.isNaN(pago.getTime())) {
    pago.setUTCHours(0, 0, 0, 0);
    return pago.getTime() <= ref.getTime() ? 'paga' : 'pendente';
  }
  if (!venc || Number.isNaN(venc.getTime())) return 'pendente';
  venc.setUTCHours(0, 0, 0, 0);
  return venc.getTime() <= ref.getTime() ? 'paga' : 'pendente';
};

export const isProjectedId = (id) =>
  typeof id === 'string' && (/^(rec|parc)-/.test(String(id)));

export const monthDiff = (from, to) =>
  (to.getUTCFullYear() - from.getUTCFullYear()) * 12 + (to.getUTCMonth() - from.getUTCMonth());

export const buildParcelaForMonth = (base, year, monthIndex, selectedMonthStr) => {
  const ini = base?.data_vencimento ? new Date(base.data_vencimento) : null;
  const fim = base?.data_termino ? new Date(base.data_termino) : null;
  if (!ini || Number.isNaN(ini.getTime())) return null;

  const sel = new Date(Date.UTC(year, monthIndex, 1));

  if (fim && monthDiff(ini, sel) > monthDiff(ini, fim)) return null;
  if (monthDiff(ini, sel) < 0) return null;

  const parcelaIndex = monthDiff(ini, sel) + 1;
  const totalMeses = fim ? (monthDiff(ini, fim) + 1) : 1;

  const anchorDay = ini.getUTCDate() || 1;
  const venc = clampDayToMonth(year, monthIndex, anchorDay).toISOString();

  const descricao = totalMeses > 1
    ? `${base.descricao} (${parcelaIndex}/${totalMeses})`
    : base.descricao;

  const proj = {
    ...base,
    id: `parc-${base.id}-${selectedMonthStr}`,
    baseId: base.id,
    isProjected: true,
    tipo: 'parcelada',
    descricao,
    data_vencimento: venc,
    data_pagamento: null,
  };

  return {
    ...proj,
    status: computeDespesaStatus({
      data_vencimento: venc,
      data_pagamento: null,
      refDate: getRefDateForMonth(year, monthIndex),
    }),
  };
};

export const inferDespesaTipo = (despesa) => {
  if (!despesa) return 'avulsa';
  if (despesa.is_recorrente) return 'recorrente';
  if (despesa.tipo === 'parcelada') return 'parcelada';
  if (despesa.data_termino) return 'parcelada';
  if (/\(\d+\/\d+\)/.test(String(despesa.descricao || ''))) return 'parcelada';
  return 'avulsa';
};
